import React from "react";
import { Modal } from "react-bootstrap";
import CloseBtn from "assets/icons/Close-1.svg";
import successBookdoc from "assets/images/success-bookdoc.png";
import successBookdoc1 from "assets/images/success-bookdoc-1.png";
import successAccu from "assets/images/success-accu.png";
import successMog from "assets/images/success-mog.png";

function RegistrationSuccessModal({ show, onHide }) {
  return (
    <Modal
      className="modal-overlay registration-success-modal"
      show={show}
      onHide={onHide}
      centered
      restoreFocus={false}
    >
      <Modal.Body className="p-0">
        <div className="success-inner">
          <div className="success-close-row">
            <button type="button" className="close-button" onClick={onHide}>
              <img src={CloseBtn} alt="close" />
            </button>
          </div>

          <div className="success-content">
            <div className="success-title-section">
              <div className="success-title">
                Your registration is confirmed!
              </div>
              <div className="success-description">
                Please visit your selected Health Lane Family Pharmacy on your
                chosen appointment date during opening hours. Exclusive bonuses
                await you after your visit:
              </div>
            </div>

            <div className="success-bonus-section">
              {/* Bonus 1 + disclaimer */}
              <div className="bonus-group">
                <div className="bonus-banner bonus-1">
                  <div className="bonus-badge">BONUS 1</div>
                  <div className="bonus-card">
                    <div className="bonus-logo-heading">
                      <img
                        src={successBookdoc}
                        alt="BookDoc"
                        className="bd-logo"
                      />
                      <div className="bonus-description-1">
                        FREE 3 months Health Coaching with BookDoc — worth
                        RM180!*
                      </div>
                    </div>
                    <img
                      src={successBookdoc1}
                      alt="BookDoc App"
                      className="bonus-image-1"
                    />
                  </div>
                </div>
                <div className="bonus-disclaimer">
                  *Upon completion of the blood glucose test, you will receive
                  an official email from BookDoc containing an activation code.
                  You can use this code to activate your BookDoc account and
                  access the health coaching programme via the BookDoc app.
                </div>
              </div>

              <div className="bonus-row-2">
                <div className="bonus-banner bonus-2">
                  <div className="bonus-badge">BONUS 2</div>
                  <div className="bonus-card">
                    <div className="bonus-description-2">
                      RM10 off Accu-Chek® Guide Me kit from Roche Malaysia
                    </div>
                    <img
                      src={successAccu}
                      alt="Accu-Chek"
                      className="bonus-image-2"
                    />
                  </div>
                </div>

                <div className="bonus-banner bonus-3">
                  <div className="bonus-badge">BONUS 3</div>
                  <div className="bonus-card">
                    <div className="bonus-description-2">
                      FREE 6-in-1 Vision Experience assessment at MOG Eyewear
                      Malaysia - worth RM350!
                    </div>
                    <img src={successMog} alt="MOG" className="bonus-image-2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RegistrationSuccessModal;
